export interface CmsPaginationMeta {
  currentPage: number;
  lastPage: number;
  perPage: number;
  from: number | null;
  to: number | null;
  total: number;
}

export function extractCmsListData(response: any): any[] {
  if (!response) return [];
  const candidates = [
    response?.data?.data,
    response?.data?.data?.data,
    response?.data,
    response,
  ];
  for (const candidate of candidates) {
    if (Array.isArray(candidate)) {
      return candidate;
    }
  }
  return [];
}

export function extractCmsPaginationMeta(
  response: any,
  fallback: { currentPage: number; perPage: number },
): CmsPaginationMeta | null {
  const raw = response?.meta ?? response?.data?.meta;
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return null;
  }

  const total = Number(raw.total ?? 0);
  const perPage = Number(raw.perPage ?? raw.per_page) || fallback.perPage;
  let lastPage = Number(raw.lastPage ?? raw.last_page) || 0;

  if (lastPage < 1 && total > 0 && perPage > 0) {
    lastPage = Math.ceil(total / perPage);
  }
  if (lastPage < 1) {
    lastPage = 1;
  }

  return {
    currentPage: Number(raw.currentPage ?? raw.current_page) || fallback.currentPage,
    lastPage,
    perPage,
    from: raw.from != null ? Number(raw.from) : null,
    to: raw.to != null ? Number(raw.to) : null,
    total,
  };
}
